// Mock Content Start
$('.js-clear-search').on('click', function () {
    $('.ab854__search__textbox').val('');
    $(this).hide();
})

// smartFiltersModal (Main Site) - Refactored

$(document).on('click', '.smart-filters', function () {
    $.modal({
        url: 'smartFiltersModal.html',
        type: 'custom',
        triggerOpen: true,
        triggerElement: $(this),
        onComplete: initSmartFiltersModalMain
    });
});

function initSmartFiltersModalMain() {
    $.ajax({
        url: 'smartFilterModalQuestions.html',
        success: function (response) {
            const $questionContainer = $('.generated__questions');
            $questionContainer.append(response);
            $('.loading').hide();

            cloneExistingPills();
            bindSubmitHandler($questionContainer);
            bindResetButton($questionContainer);
        }
    });
}

function cloneExistingPills() {
    const $pillSource = $('#selected-filters');
    const pillTexts = $pillSource.find('.pill-button--light-grey span').map(function () {
        return $(this).text().trim();
    }).get();

    const $modal = $('.modal');
    const $questionContainer = $modal.find('.generated__questions');

    $questionContainer.find('input[type="checkbox"]').each(function () {
        const $input = $(this);
        const inputId = $input.attr('id');
        const $label = $modal.find(`label[for="${inputId}"] .push-button__copy`);
        if ($label.length && pillTexts.includes($label.text().trim())) {
            $input.prop('checked', true);
        }
    });

    renderPillClones($pillSource);
}

function renderPillClones($pillSource) {
    const $modal = $('.modal');
    const $filteredText = $('#filtered-text');
    const $instructionText = $modal.find('p.u-text--xl');

    if (
        !$pillSource.find('.pill-button--light-grey').length ||
        !$instructionText.length ||
        !$filteredText.length
    ) return;

    const $filteredTextClone = $filteredText.clone().removeAttr('id').addClass('filtered-by');
    const $pillCloneContainer = $pillSource.clone().removeAttr('id').removeClass('u-margin-t--xs');

    $pillCloneContainer.removeClass('js-horizontal-scroll horizontal-scroll');
    const $ul = $pillCloneContainer.find('ul');
    $ul
        .removeClass()
        .addClass('u-flex u-margin-b--none')
        .css({ listStyle: 'none', flexWrap: 'wrap', rowGap: '5px' });

    $ul.find('.pill-button--light-grey').each(function () {
        const $pill = $(this);
        const labelText = $pill.find('span').text().trim();

        $modal.find('label.push-button').each(function () {
            const $label = $(this);
            const $copy = $label.find('.push-button__copy');
            const labelFor = $label.attr('for');
            if (labelText === $copy.text().trim() && labelFor) {
                $pill.attr('data-input-id', labelFor);
            }
        });

        $pill.find('button').on('click', function () {
            const labelText = $pill.find('span').text().trim();

            // Loop through all labels in the modal to find a match
            $modal.find('label.push-button').each(function () {
                const $label = $(this);
                const $copy = $label.find('.push-button__copy');
                const labelTextInModal = $copy.text().trim();
                if (labelText === labelTextInModal) {
                    const inputId = $label.attr('for');
                    const $input = $modal.find(`#${inputId}`);
                    if ($input.length) {
                        $input.prop('checked', false);
                    }
                }
            });

            $pill.closest('li').remove();

            // Remove Clear Filters button if no pills remain
            if (!$ul.find('.pill-button--light-grey').length) {
                $pillCloneContainer.find('.js-clear-filters-btn').remove();
            }
        });

    });

    if (!$pillCloneContainer.find('.js-clear-filters-btn').length) {
        const $clearBtn = $('<button class="js-clear-filters-btn pill-button pill-button--black u-white-space--nowrap">Clear Filters</button>');
        $clearBtn.on('click', function () {
            $pillCloneContainer.find('.pill-button--light-grey').each(function () {
                const inputId = $(this).data('input-id');
                const $input = $modal.find(`#${inputId}`);
                $input.prop('checked', false);
                $(this).closest('li').remove();
                $('.filtered-by').remove();
            });
            $clearBtn.remove();
        });
        const $li = $('<li class="horizontal-scroll__item horizontal-scroll__item--basis-none"></li>').append($clearBtn);
        $ul.append($li);
    }

    const $replacement = $('<div class="u-margin-t--xl u-flex u-margin-b--xxl u-flex--align-items-start">')
        .append($filteredTextClone)
        .append($pillCloneContainer);

    $instructionText.replaceWith($replacement);
}

function bindSubmitHandler($questionContainer) {
    document.querySelector('.submit-questions')?.addEventListener('click', function () {
        const checkedInputs = $questionContainer.find('input[type="checkbox"]:checked');
        const pillContainer = document.getElementById('selected-filters');
        const filteredText = document.getElementById('filtered-text');
        const filtersContainer = document.querySelector('.filters-container');

        pillContainer.innerHTML = '';
        const ul = document.createElement('ul');
        ul.className = 'horizontal-scroll__item-wrap u-margin-b--none';

        checkedInputs.each(function () {
            const input = this;
            const label = $questionContainer.find(`label[for="${input.id}"] .push-button__copy`).text().trim();
            if (!label) return;

            const li = document.createElement('li');
            li.className = 'horizontal-scroll__item horizontal-scroll__item--basis-none';

            const pill = document.createElement('div');
            pill.className = 'pill-button pill-button--light-grey';
            const span = document.createElement('span');
            span.textContent = label;
            pill.appendChild(span);

            const closeBtn = document.createElement('button');
            closeBtn.type = 'button';
            closeBtn.className = 'u-margin-l--xs';
            closeBtn.innerHTML = `
        <span class="icon icon--x">
          <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
            <path d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z"></path>
          </svg>
        </span>`;

            closeBtn.addEventListener('click', () => {
                input.checked = false;
                li.remove();
                if (!ul.querySelectorAll('.pill-button--light-grey').length) {
                    document.querySelector('.clear-btn')?.remove();
                    filteredText.classList.add('u-hide');
                }
            });

            pill.appendChild(closeBtn);
            li.appendChild(pill);
            ul.appendChild(li);
        });

        if (checkedInputs.length > 0) {
            const clearBtn = document.createElement('button');
            clearBtn.className = 'clear-btn pill-button pill-button--black u-white-space--nowrap u-margin-l--lg';
            clearBtn.textContent = 'Clear Filters';

            clearBtn.addEventListener('click', () => {
                $questionContainer.find('input[type="checkbox"]').prop('checked', false);
                pillContainer.innerHTML = '';
                filteredText.classList.add('u-hide');
                clearBtn.remove();
            });

            if (!filtersContainer.querySelector('.clear-btn')) {
                filtersContainer.appendChild(clearBtn);
            }
            filteredText.classList.remove('u-hide');
        } else {
            $('#filtered-text').addClass('u-hide');
            $('.clear-btn').remove();
        }

        pillContainer.appendChild(ul);
        setTimeout(() => {
            const $scrollEl = $('.js-horizontal-scroll');
            if ($scrollEl.length && typeof $scrollEl.horizontalScroll === 'function') {
                $scrollEl.horizontalScroll();
            }
        }, 0);

        $('.js-modal-close').trigger('mousedown');
        $('.js-clear-search').show();
    });
}

function bindResetButton($container) {
    document.querySelector('.reset-questions')?.addEventListener('click', () => {
        $container.find('input[type="checkbox"]').prop('checked', false);
        $('#selected-filters').empty();
        $('#filtered-text').addClass('u-hide');
        $('.js-refine-label').removeClass('u-hide');
        $('.ab854__search__textbox').val('');
        $('.js-clear-search').hide();
        $('.clear-btn').remove();
        $('.js-modal-close').trigger('mousedown');
    });
}

// Mock Content End


// WEBPACK FOOTER //
// ./src/scripts/modules/abtest/smart-filters.js